export const NAMESPACE = 'DEMO';

export enum DemoUIState {
  WALLET = 'wallet',
  SEND_OPTIONS = 'options',
  TRANSACTION = 'transaction',
  TRANSACTIONS = 'transactions',
  // from WithdrawalUIState
  RECEIVER = 'receiver',
  PREPARE = 'prepare',
  TRANSFER = 'transfer',
  STATUS = 'status',
}
